/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portals_Connected_OnlyInputs */

const cs_portals_connected_only = /** @type {(inputs: Portals_Connected_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jen připojené (${i?.count})`)
};

const en_portals_connected_only = /** @type {(inputs: Portals_Connected_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected only (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Connected only ({count})" |
*
* @param {Portals_Connected_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_connected_only = /** @type {((inputs: Portals_Connected_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Connected_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_connected_only(inputs)
	return cs_portals_connected_only(inputs)
});